import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StorageList } from 'containers';
import { Query } from 'react-apollo';
import { FETCH_ALL_STORAGES } from 'api/storage';
import { FieldWrapper, ErrorBoundary } from 'common/components';

const Storage = ({ showMapFlag }) => (
  <ErrorBoundary>
    <Query
      query={FETCH_ALL_STORAGES}
      fetchPolicy="cache-and-network"
      variables={{
        active: true /* TODO: Make this value toggleable */,
      }}
    >
      {({ loading, error, data }) => {
        if (loading || error) return null; // handle side effects here in the future.
        const { getAllStorages } = data;

        const fieldWrapperProps =
          getAllStorages.length === 0
            ? { showFields: true }
            : { showStorages: true, showStorageMarkers: true };

        return (
          <FieldWrapper
            showMapFlag={showMapFlag}
            useMaxZoomService
            {...fieldWrapperProps}
          >
            <StorageList storages={getAllStorages} />
          </FieldWrapper>
        );
      }}
    </Query>
  </ErrorBoundary>
);

Storage.propTypes = {
  showMapFlag: PropTypes.bool,
};

const mapState = ({ field: { showMapFlag } }) => ({ showMapFlag });

export default connect(mapState)(Storage);



// WEBPACK FOOTER //
// ./src/pages/Storage/index.js